/**
 * Homepage header fade and optional fancy scroll logo.
 * Config is injected via window.homepageHeaderConfig from sections/header.liquid.
 */
(function () {
  'use strict';

  const END_WIDTH = 130;
  const Z_INDEX_NAV = 6;
  const SCROLL_START_THRESHOLD = 1;

  const BREAKPOINTS = {
    mobile: {
      endTop: 7.5,
      zIndexHero: 3,
    },
    desktop: {
      endTop: 10.5,
      zIndexHero: 5,
    },
  };

  const config = window.homepageHeaderConfig;
  if (!config) return;

  let logoEl;
  let headerWrapper;

  function initElements() {
    logoEl = document.getElementById('fancy-scroll-logo');
    headerWrapper = document.getElementById('header-wrapper');
  }

  function getHeroEl() {
    return document.querySelector('.random-hero-images');
  }

  function getBreakpointConfig() {
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    const bp = isMobile ? 'mobile' : 'desktop';
    return { ...config[bp], ...BREAKPOINTS[bp], endWidth: END_WIDTH, zIndexNav: Z_INDEX_NAV };
  }

  function lerp(start, end, progress) {
    return start + (end - start) * progress;
  }

  function getStartMetrics(cfg) {
    const viewportWidth = window.innerWidth;
    return {
      widthPx: (viewportWidth * cfg.startWidth) / 100,
      topPx: (viewportWidth * cfg.startTopVw) / 100,
    };
  }

  function clearLogoInlineStyles() {
    if (!logoEl) return;
    logoEl.classList.remove('scrolled-past');
    logoEl.style.removeProperty('width');
    logoEl.style.removeProperty('top');
    logoEl.style.removeProperty('z-index');
  }

  function updateHeaderFade(scrollTop) {
    if (!headerWrapper) return;

    const header = document.querySelector('.header');
    if (header && header.classList.contains('menu-open')) return;

    const heroEl = getHeroEl();
    const heroHeight = heroEl ? heroEl.offsetHeight : window.innerHeight;
    const fadeStart = heroHeight * config.headerFadeStartRatio;
    let opacity = 0;

    if (scrollTop > fadeStart) {
      opacity = ((scrollTop - fadeStart) / config.headerFadeDistance) * config.headerFadeSpeed;
      if (opacity > 1) opacity = 1;
    }

    headerWrapper.style.setProperty('background-color', `rgba(230,230,230,${opacity})`, 'important');
    headerWrapper.style.setProperty('color', '#FFFFFF', 'important');
  }

  function applyEndState() {
    if (!logoEl) return;
    logoEl.classList.add('scrolled-past');
    logoEl.style.removeProperty('width');
    logoEl.style.removeProperty('top');
    logoEl.style.removeProperty('z-index');
  }

  function applyAnimatedState(scrollTop, cfg) {
    if (!logoEl) return;

    const distance = cfg.scrollDistance;
    const progress =
      distance > 0 ? Math.min(Math.max(scrollTop / distance, 0), 1) : scrollTop > 0 ? 1 : 0;

    if (progress >= 1) {
      applyEndState();
      return;
    }

    logoEl.classList.remove('scrolled-past');

    const { widthPx: startWidthPx, topPx: startTopPx } = getStartMetrics(cfg);
    const widthPx = lerp(startWidthPx, cfg.endWidth, progress);
    const topPx = lerp(startTopPx, cfg.endTop, progress);

    logoEl.style.width = `${widthPx}px`;
    logoEl.style.top = `${topPx}px`;
    logoEl.style.zIndex = String(cfg.zIndexHero);
  }

  function updateFancyLogo(scrollTop) {
    if (!config.fancyLogo || !logoEl) return;

    if (scrollTop < SCROLL_START_THRESHOLD) {
      clearLogoInlineStyles();
      return;
    }

    applyAnimatedState(scrollTop, getBreakpointConfig());
  }

  function onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    updateFancyLogo(scrollTop);
    updateHeaderFade(scrollTop);
  }

  function init() {
    initElements();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.matchMedia('(max-width: 989px)').addEventListener('change', onScroll);
  window.addEventListener('resize', onScroll, { passive: true });
})();
